import React, {useState, useEffect, useContext,useRef} from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import {FormValidator,useFormValidator,Message,Inputs,Scrollable} from 'coaz-ui';
import client from '../client';
import { useLocation,useNavigate } from 'react-router-dom';
import SubmitButton from './SubmitButton';
import {useIAgree,IAgree} from './IAgree';

const FinishRegistration = () => {
    const [firstname,setFirstname] = useState('');
    const [lastname,setLastname] = useState('');
    const [currentUsername,setCurrentUsername] = useState('');
    const [newUsername,setNewUsername] = useState('');
    const [oldPassword,setOldPassword] = useState('');
    const [newPassword,setNewPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');
    const [message,setMessage] = useState({content:'',success:false}); 
    const [email,setEmail] = useState('');
	const [loading,setLoading] = useState(true);
    const path = useLocation().pathname;
    const minWidth = 240;
    const [inputWidth,setInputWidth] = useState(minWidth);
    const [height,setHeight] = useState(0);
    const mainContainerRef = useRef(null);
    const inputsRef = useRef(null);
    const {request,errorMessage} = client;

    const {iAgree,setIAgree} = useIAgree(false);

    const params = new URLSearchParams(window.location.search);

    const navigate = useNavigate();

    const submit = async (e) => {
        setMessage({content:'',success:true});
        if(params && params.get('userId') && newPassword === confirmPassword) {
			setLoading(true);
            await request('PUT','users/finish-registration',null,{
                userId:params.get('userId'),
                newUsername:newUsername,
                email:email,
                oldPassword:oldPassword,
                newPassword:newPassword
            })
            .then((response) => {
                if(response && response == true) {
                    navigate(-1);
                } else {
                    setMessage({content:errorMessage(response),success:false});
                }
            })
            .catch((error) => {
                setMessage({content:errorMessage(error),success:false});
            })
			.finally(() => {
				setLoading(false)
			})
        } else {
            setMessage({content:"New password and confirm password didn't match, try again!",success:false});
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const inputs = [
        {
            label:"Firstname",
            type:"text", 
            id:"firstname", 
            name:"firstname",  
            value:firstname?firstname:'',
            disabled:true
        },
        {
            label:"Lastname",
            type:"text", 
            id:"lastname", 
            name:"lastname",  
            value:lastname?lastname:'',
            disabled:true
        },
        {
            label:"Current username",
            type:"text", 
            id:"username", 
            name:"username",  
            value:currentUsername?currentUsername:'',
            disabled:true
        },
        {
            label:"New username",
            type:"text", 
            id:"newUsername", 
            name:"newUsername",  
            value:newUsername?newUsername:'',
            placeholder:"Enter new username...",
            onChange:(e) => handleChange(e,(e) => {
                setNewUsername(e.target.value.toLowerCase());
            }),
            register:register,
            checks:['empty','username'],
            errors:errors
        },
        {
            label:"Email",
            type:"text",
            id:"email", 
            name:"email",  
            value:email?email:'',
            placeholder:"Enter email...",
            onChange:(e) => handleChange(e,(e) => {
                setEmail(e.target.value);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:"Current password",
            type:"password",
            id:"oldPassword", 
            name:"oldPassword",  
            value:oldPassword?oldPassword:'',
            placeholder:"Enter old password...",
            onChange:(e) => handleChange(e,(e) => {
                setOldPassword(e.target.value);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        },
        { 
            label:"New password",
            type:"password",
            id:"newPassword", 
            name:"newPassword",  
            value:newPassword?newPassword:'',
            placeholder:"Enter new password...",
            onChange:(e) => handleChange(e,(e) => {
                setNewPassword(e.target.value);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        },
        { 
            label:"Confirm password",
            type:"password",
            id:"confirmPassword", 
            name:"confirmPassword",  
            value:confirmPassword?confirmPassword:'',
            placeholder:"Confirm password...",
            onChange:(e) => handleChange(e,(e) => {
                setConfirmPassword(e.target.value);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        }
    ]

    useEffect(() => {
        if(params && params.get('userId')) {
            request('GET',`users/${params.get('userId')}`)
            .then((response) => {
                if(response && response.ref) {
                    setFirstname(response.firstname);
                    setLastname(response.lastname);
                    setCurrentUsername(response.name);
                    setEmail(response.email);
                } else {
                    setMessage({content:errorMessage(response),success:false});
                }
            })
            .catch((error) => {
                setMessage({content:errorMessage(error),success:false});
            })
			.finally(() => {
				setLoading(false);
			})
        }

        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                if(mainContainerRef.current) {
                    let maxHeight = window.innerHeight * (90/100);
                    if(maxHeight < entry.target.offsetHeight) {
                        setHeight(maxHeight);
                    } else {
                        setHeight(0);
                    }
                }
            }
        });

        if(inputsRef.current) {
            observer.observe(inputsRef.current)
        }
            
        return () => {
            observer.disconnect();
        };
    },[path])

    return (
    <div ref={mainContainerRef} className='flex items-center justify-center w-full h-full p-4 overflow-hidden'>
        <div style={{height:!height || height == 0?'auto':height+'px', backdropFilter:'blur(20px)'}} 
            className='flex w-full md:w-[720px] bg-[rgba(255,255,255,.8)] p-4 shadow-2xl rounded-2xl overflow-hidden'>
            <FormValidator>
                <Scrollable vertical={true}>
                    <div ref={inputsRef} className='flex flex-col items-center w-full space-y-4 h-fit'>
                        <img onClick={(e) => navigate('/_login')} src='/logo.png' className='w-32 h-32 cursor-pointer'/>
                        <div className='flex flex-row space-x-2 text-2xl'><p className='font-bold text-[rgb(0,175,240)]'>FINISH</p><p className='font-light'>REGISTRATION</p></div>
                        <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
                        <IAgree iAgree={iAgree} setIAgree={setIAgree}/>
                        <SubmitButton onSubmit={handleSubmit} width={minWidth} disabled={!iAgree} loading={loading}/>
                        <Message message={message}/>
                    </div>
                </Scrollable>
            </FormValidator>
        </div>
    </div>
    )
}

export default FinishRegistration
